<template>
  <div>
    <MainMenu :withNav="true" />
    <router-view/>
    <Footer/>
  </div>
</template>
<script>
  import MainMenu from "../components/app/MainMenu";
  import Footer from "../components/app/Footer";
  export default {
    name: "MainLayout",
    components: {Footer, MainMenu},
  };
</script>

<style lang="scss" scoped></style>
